


































































import Vue from "vue";
import TeamCalendarModule from "@/views/Calendar/TeamCalendarModule";
import { getModule } from "vuex-module-decorators";
import router from "@/router";
import { mapGetters } from "vuex";
import GetterTypes from "@/store/GetterTypes";

export default Vue.extend({
  name: "TeamCalendarNav",
  data() {
    return {
      module: getModule(TeamCalendarModule, this.$store)
    };
  },
  props: {
    title: {
      type: String
    }
  },
  methods: {
    setRelated(checked: boolean) {
      router.push({
        query: {
          ...this.$route.query,
          related: (checked ? true : false).toString()
        }
      });
    }
  },
  computed: {
    orgName(): string {
      return this.module.organization ? this.module.organization.name : "";
    },
    ...mapGetters({
      playersAndTeams: GetterTypes.GET_PLAYERS_AND_TEAMS
    })
  }
});
